import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PrimeModule } from './prime/prime.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { TokenInterceptor } from './utils/interceptor/token.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiModule } from './api/api.module';
import { environment } from 'src/environments/environment';
import { SharedModule } from './shared/shared.module';
import myLocaleIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
import { AuthenticationInterceptor } from './utils/interceptor/authentication.interceptor';
import { LicenseInterceptor } from './utils/interceptor/license.interceptor';
import { TicketLockHolderInterceptor } from './utils/interceptor/ticket-lock-holder.interceptor';
import { NxLicenseErrorPageComponent } from './shared/nx-license-error-page/nx-license-error-page.component';
import { LicenseStateService } from './services/license-state.service';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ForgotPasswordComponent } from './password-reset/forgot-password.component';
import { ResetPasswordComponent } from './password-reset/reset-password.component';

registerLocaleData(myLocaleIt);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    NxLicenseErrorPageComponent,
    PrivacyPolicyComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    PrimeModule,
    HttpClientModule,
    SharedModule,
    JwtModule.forRoot({
      config: {
        disallowedRoutes: [''],
      },
    }),
    ApiModule.forRoot({
      rootUrl: environment.baseUrl,
    }),
  ],
  providers: [
    ConfirmationService,
    MessageService,
    LicenseStateService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LicenseInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TicketLockHolderInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'it' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
